import { Button } from "@/components/ui/Button";
import { cn } from "@/lib/utils";

const TabsBar = ({ activeTab, onTabChange, tabs }) => {
    return (
        <div
            className="flex items-center w-full lg:w-auto bg-background-tab border border-border-primary rounded-xl px-1.5 py-1.5 gap-1 overflow-x-auto"
            role="tablist"
            aria-label="Tenant detail tabs"
        >
            {tabs.map((tab) => {
                const isActive = activeTab === tab.id;

                return (
                    <Button
                        key={tab.id}
                        type="button"
                        role="tab"
                        aria-selected={isActive}
                        aria-controls={`org-tabpanel-${tab.id}`}
                        id={`org-tab-${tab.id}`}
                        tabIndex={isActive ? 0 : -1}
                        onClick={() => onTabChange(tab.id)}
                        className={cn(
                            "flex items-center justify-center gap-2 px-3 py-1 rounded-lg text-[12px] font-medium whitespace-nowrap transition-all duration-200 border",
                            isActive
                                ? "bg-background-tertiary text-text-primary border-white/10 shadow-sm"
                                : "border-transparent text-text-secondary hover:text-text-primary hover:bg-background-secondary/60"
                        )}
                    >
                        <span>{tab.label}</span>
                    </Button>
                );
            })}
        </div>
    );
};

export default TabsBar;